<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="hidden" type="checkbox" [(ngModel)]="fieldOptions.hidden">
    <span><b>Hidden</b></span>
  </label>
</div>